import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Drawer, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

function BulkUploadLogsDrawer({ open, onClose, bulkUploadId }) {
  const dispatch = useDispatch();
  const { bulkUpload, snackbarMessages } = useTranslatedMessages();
  const drawerLabels = bulkUpload?.logs_drawer ?? {};
  const bulkUploadMessages = snackbarMessages.bulk_upload ?? {};
  const [logContent, setLogContent] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !bulkUploadId) {
      return;
    }

    setLoading(true);
    setLogContent('');

    apiClient
      .get(`/bulk-uploads/${bulkUploadId}/download`, {
        params: { downloadType: 'log' },
        responseType: 'text',
        headers: {
          'Content-Type': undefined,
        },
      })
      .then((response) => {
        setLogContent(typeof response.data === 'string' ? response.data : String(response.data ?? ''));
      })
      .catch(() => {
        dispatch(
          showSnackbar({
            message: bulkUploadMessages.download_error,
            severity: 'error',
          }),
        );
        onClose();
      })
      .finally(() => {
        setLoading(false);
      });
  }, [open, bulkUploadId, dispatch, bulkUploadMessages.download_error, onClose]);

  return (
    <Drawer anchor="right" open={open} onClose={onClose} PaperProps={{ sx: { width: { xs: '100%', sm: 480 } } }}>
      <Box display="flex" alignItems="center" justifyContent="space-between" px={2} py={1.5}>
        <Typography variant="h6">{drawerLabels.title ?? 'Processing Logs'}</Typography>
        <IconButton onClick={onClose} aria-label={drawerLabels.close ?? 'Close logs drawer'}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box px={2} pb={2} sx={{ overflow: 'auto', flex: 1 }}>
        {loading ? (
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress size={28} />
          </Box>
        ) : (
          <Typography
            component="pre"
            sx={{
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              fontFamily: 'monospace',
              fontSize: 13,
              m: 0,
            }}
          >
            {logContent || (drawerLabels.empty ?? 'No logs available.')}
          </Typography>
        )}
      </Box>
    </Drawer>
  );
}

export default BulkUploadLogsDrawer;
